/** API 베이스 URL — 배포 시 같은 도메인(상대 경로), 로컬 개발 시 .env.development 참고 */
function resolveMainURL(): string {
  return 'https://www.yeplat.com';
}

const MainURL = resolveMainURL();

export default MainURL;
